import { apiPrefix } from "./common";

import axios from "axios";

export default {
    apiProducts(site_id, path) {
        return apiPrefix(
            "/websites/" + site_id + "/products" + (path ? "/" + path : "")
        );
    },

    getProducts(site_id, page, per_page, params) {
        return axios.get(this.apiProducts(site_id), {
            params: {
                page,
                per_page,
                ...params,
            },
        });
    },

    getProduct(site_id, product_id) {
        return axios.get(this.apiProducts(site_id, product_id));
    },

    putProduct(site_id, product_id, form = {}) {
        return axios.put(this.apiProducts(site_id, product_id), form);
    },
};
